module.exports = __webpack_public_path__ + "01_short_black.1a2b9364.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_short_black.png
// module id = kTO+
// module chunks = 0